import { Component, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { $app } from '@app/app.service'
import { HttpUserService } from '@app/data/service/http-user.service'
import { AuthService } from '@core/auth.service'
import { NavigatorService } from '@core/navigator.service'
import { UserService as CoreUserService } from '@core/user.service'
import { User } from '@data/model/user.model'
import * as StageActions from '@data/store/stage/stage.actions'
import { AppState } from '@data/store/storage.module'
import { Store } from '@ngrx/store'
import { KeycloakProfile } from 'keycloak-js'
import { from, of, Subscription } from 'rxjs'
import { catchError, filter, tap } from 'rxjs/operators'
import { InnplaceList } from './data/model/innplaceList.model'
import { innplaceList } from './data/store/stage/stage.selectors'
import { PrivacyDialogEntity } from './entity/dialog/privacy/privacy-dialog.entity'

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
   console: boolean = $app.core.modeDevel
   logPrefix: string = '@app - ' + this.constructor.name

   $app = $app //for use in template

   sub = new Subscription()

   constructor(
      private userSrv: HttpUserService,
      public dialog: MatDialog,
      private store: Store<AppState>,
      private auth: AuthService,
      private userService: CoreUserService,
      private nav: NavigatorService,
      private _router: Router
   ) {}

   ngOnInit() {
      if (this.auth.hasLicence()) {
         this.$app.core.setup()
         this.setUser()
         this.setupUser()
         this.setNavigationElements()
         this.store.dispatch(StageActions.loadInnplaceLists())

         this.sub.add(
            this.store.select(innplaceList).subscribe((res: InnplaceList) => {
               $app.setLists(res)
               $app.setListsNames()
            })
         )
      } else {
         this.accessDenied()
      }

      this.sub.add(
         this.auth.licenceSubject$.subscribe((hasLicence) => {
            if (!hasLicence) {
               if (!this._router.url.includes('access-denied')) {
                  this.accessDenied()
               }
            } else if (this._router.url.includes('access-denied')) {
               window.location.reload()
            }
         })
      )
   }

   ngOnDestroy(): void {
      this.sub.unsubscribe()
   }

   onActivateRoute() {
      if (this.console) console.log(this.logPrefix, 'onActivateRoute')

      if (!this.auth.hasLicence()) return

      this.nav.refreshParams()

      const currentPage = $app.core.getPageByRoute(this.nav.currentRoute)

      if (this.console) console.log(this.logPrefix, 'onActivateRoute - currentPage', currentPage)

      $app.core.appData.currentPageName = currentPage.name
      this.setLayoutElements()
   }

   openPrivacyModal() {
      if (this.console) console.log(this.logPrefix, 'OpenPrivacyModal')

      return new Promise((resolve, reject) => {
         $app.core.spinnerShow()

         this.userSrv.getPrivacyStatementHTML().subscribe(
            (res) => {
               console.log('ressss', res)
               if (this.console) console.log(this.logPrefix, 'loadInnplaceLists RESPONSE')

               if (!res) {
                  resolve(false)
               } else {
                  const dialogRef = this.dialog.open(PrivacyDialogEntity, {
                     width: '620px',
                     data: {
                        innerHTML: res,
                     },
                  })

                  dialogRef.afterClosed().subscribe((result) => {
                     console.log('The dialog was closed')
                  })
                  resolve(res)
               }

               $app.core.spinnerHide()
            },
            (error) => {
               resolve(false)
               $app.core.spinnerHide()
            }
         )
      })
   }

   private setUser() {
      const mn = this.setUser.name
      from(this.auth.keycloakAngular.loadUserProfile())
         .pipe(
            filter((res) => res != null && res != undefined),
            tap((res) => console.log(this.logPrefix, mn, 'Keycloack User profile res:', res)),
            catchError((error) => {
               console.error(this.logPrefix, mn, 'Cannot retrive user info...')
               return of(error)
            })
         )
         .subscribe((user: KeycloakProfile) => {
            this.store.dispatch(StageActions.setKcUser({ user: user }))
         })
   }

   private setupUser() {
      if (this.console) console.log(this.logPrefix, 'setupUser - logged')

      this.loadCurrentUser().then((userData: User) => {
         if (this.console) console.log(this.logPrefix, 'setupUser loadCurrentUser RETURN', userData)
         this.store.dispatch(StageActions.setUser({ user: userData }))
         this.userService.setData(userData)
      })
   }

   private setNavigationElements() {
      if (this.console) console.log(this.logPrefix, 'setNavigationElements')
      let pages: any = {
         dashboard: { route: '/dashboard', label: 'dashboard', iconName: 'dashboard_svg', params: { onSetup: ['loginCheck'] } },
         privacy_statement: { route: '/privacy-statement', label: 'privacy-statement', iconName: 'dashboard_svg' },
         prefiltered_sector: { route: '/sectors', label: 'prefiltered', iconName: 'prefiltered_sector_svg' },
         prefiltered_services: { route: '/services', label: 'prefiltered', iconName: 'prefiltered_services_mat' },
         prefiltered_grant: { route: '/grants', label: 'prefiltered', iconName: 'prefiltered_grant_mat' },
         account_profile: { route: '/account', label: 'edit_account', iconName: 'person' },
         test: { route: '/test', label: 'test', iconName: 'question_mat' },
      }

      let icons: any = {
         dashboard_svg: { ref_active: '/assets/icons/sidebar/dashboard-active.svg', ref_deactive: '/assets/icons/sidebar/dashboard-default.svg', type: 'svg' },
         prefiltered_mat: { ref_active: '/assets/icons/sidebar/browse-active.svg', ref_deactive: '/assets/icons/sidebar/browse-default.svg', type: 'svg' },
         prefiltered_sector_svg: { ref_active: '/assets/icons/sidebar/sectors.svg', ref_deactive: '/assets/icons/sidebar/sectors.svg', type: 'svg' },
         prefiltered_services_mat: { ref_active: '/assets/icons/sidebar/project.svg', ref_deactive: '/assets/icons/sidebar/project.svg', type: 'svg' },
         prefiltered_grant_mat: { ref_active: '/assets/icons/sidebar/grants.svg', ref_deactive: '/assets/icons/sidebar/grants.svg', type: 'svg' },
         person: { ref: 'person', type: 'mat', class: 'material-icons-outlined' },
      }

      if (this.console) console.log(this.logPrefix, 'setNavigationElements icons', icons)
      if (this.console) console.log(this.logPrefix, 'setNavigationElements pages', pages)

      $app.core.setIcons(icons)
      $app.core.setPages(pages)
   }

   private setLayoutElements() {
      if (this.console) console.log(this.logPrefix, 'setLayoutElements - layout2:', $app.core.appData)

      $app.core.setMenuItems({
         dashboard: { type: 'page', params: { pageName: 'dashboard' } },
         prefiltered_submenu: {
            type: 'submenu',
            params: { label: 'prefiltered', iconName: 'prefiltered_mat', list: ['prefiltered_sector', 'prefiltered_services', 'prefiltered_grant'] },
         },
         prefiltered_sector: { type: 'page', params: { label: 'by_sectors', pageName: 'prefiltered_sector' } },
         prefiltered_services: { type: 'page', params: { label: 'by_services', pageName: 'prefiltered_services' } },
         prefiltered_grant: { type: 'page', params: { label: 'by_grant_programme', pageName: 'prefiltered_grant' } },
      })

      $app.core.setMenu('main', ['dashboard', 'prefiltered_submenu'])
   }

   private loadCurrentUser() {
      if (this.console) console.log(this.logPrefix, 'loadCurrentUser')

      return new Promise((resolve, reject) => {
         $app.core.spinnerShow()

         this.userSrv.getCurrent().subscribe(
            (res) => {
               if (this.console) console.log(this.logPrefix, 'loadCurrentUser RESPONSE')

               if (!$app.core.code.isObject(res)) {
                  resolve(false)
               } else {
                  console.log('res, res', res)
                  this.store.dispatch(StageActions.setPrivacyStatement({ privacyStatement: res?.privacyStatementAccepted || false }))
                  resolve(res)
               }

               $app.core.spinnerHide()
            },
            (error) => {
               resolve(false)
               $app.core.spinnerHide()
            }
         )
      })
   }

   private accessDenied() {
      if (this.console) console.log(this.logPrefix, 'user does not have licence...')
      this._router.navigate(['/access-denied'])
   }
}

